webpackJsonp([19],{

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return floatMenu; });
/**
 * Created by lycheng on 2017/12/4.
 * 浮动导航，默认是右边悬浮，需要改变位置可使用
 * floatMenu.config.position重新赋值
 */

// 右边导航
var floatMenu = {
  config: {
    top: 90,
    $container: $('html,body'),
    checkedClass: 'nav-checked',
    position: {
      top: {
        position: 'absolute',
        top: '600px',
        bottom: 'auto'
      },
      middle: {
        position: 'fixed',
        top: '150px',
        bottom: 'auto'
      },
      bottom: {
        // position: 'fixed',
        // top: '500px',
        // bottom: '0'
      },
      minTop: {
        position: 'fixed',
        top: '550px',
        bottom: 'auto'
      },
      minBottom: {
        position: 'fixed',
        top: '150px',
        bottom: 'auto'
      }
    }
  },
  init: function init() {
    floatMenu.bindEvent();
    floatMenu.methods.rePosition();
  },
  bindEvent: function bindEvent() {
    $('.js-service-nav-fall li').off('click').on('click', function () {
      var target = $(this).attr('target');
      floatMenu.methods.toPosition(target);
    });
    window.onscroll = function () {
      floatMenu.methods.rePosition();
    };
    window.onscroll();
  },
  methods: {
    toPosition: function toPosition(target) {
      var top = $('.' + target).offset().top - floatMenu.config.top;
      floatMenu.config.$container.animate({ scrollTop: Math.floor(top) }, 500);
    },
    rePosition: function rePosition() {
      var tops = [];
      var top = $('body').scrollTop() || $('html').scrollTop();
      var $navCon = $('.js-service-nav-fall');
      var $navItem = $('.js-service-nav-fall li');
      var targets = [];
      var i = 0;
      var position = floatMenu.config.position;
      $navItem.each(function () {
        targets.push($(this).attr('target'));
      });

      for (i = 0; i < targets.length; i++) {
        tops.push(Math.floor($('.' + targets[i]).offset().top) - floatMenu.config.top);
      }
      tops.push(tops[i - 1] + $('.' + targets[i - 1]).height());

      for (i = 0; i < targets.length; i++) {
        if (top >= tops[i]) {
          $navItem.removeClass(floatMenu.config.checkedClass);
          $navItem.filter('[target="' + targets[i] + '"]').addClass(floatMenu.config.checkedClass);
        }
      }

      if (top >= tops[0]) {
        if (top + $navCon.height() + floatMenu.config.top > tops[tops.length - 1]) {
          $navCon.css(position.bottom);
        } else {
          $navCon.css(position.middle);
        }
      } else {
        $navCon.css(position.top);
      }
    }

  }
};


/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serviceQA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return serviceTopbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_libs_utils_suspension__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_float_menu__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_libs_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_api_user__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_libs_utils_login__ = __webpack_require__(7);
/**
 * Created by lycheng on 2017/12/4.
 * 所有service都需要引入
 */








function serviceQA() {
  var $serviceQA = $('.service-item-qa');
  // 问答题超过两组时隐藏超出部分
  if ($serviceQA.length) {
    var oLi = $serviceQA.find('li');
    if (oLi.length <= 4) {
      $('.service-qa-more').hide();
    }
    for (var i = 0; i < oLi.length; i++) {
      if (i >= 4) {
        oLi.eq(i).hide();
      }
    }
  }
  // 点击查看更多显示超出部分
  $('.service-qa-more').click(function () {
    var oLi = $serviceQA.find('li');
    oLi.show();
    $(this).hide();
  });
}

function serviceTopbar() {
  var $serviceTopbar = $('.service-topbar');
  if ($serviceTopbar.length) {
    $(window).scroll(function () {
      var windowPosition = $(window).scrollTop();
      if (windowPosition >= 450) {
        $('.service-topbar').show();
      } else {
        $('.service-topbar').hide();
      }
    });
  }
}

// 滑动到产品价格
function scrollToPrice() {
  $('html,body').animate({
    scrollTop: $('.service-item-price').offset().top - 100
  }, 1e3);
}

function bindEvent() {
  // banner下立即申请
  $('.banner-to-service-manage').click(function () {
    var serviceKey = this.dataset.serviceKey;
    if (serviceKey === 'face' || serviceKey === 'isv' || serviceKey === 'xpush') {
      serviceKey = 'base';
    }
    Object(__WEBPACK_IMPORTED_MODULE_3_js_libs_utils__["g" /* toUrl */])(__WEBPACK_IMPORTED_MODULE_0_config__["a" /* config */].CONSOLE + 'services/' + serviceKey, '_blank');
  });
  $('.to-price').click(function () {
    scrollToPrice();
  });
  // 滑动到产品价格
  var hash = location.hash;
  if (hash === '#price') {
    scrollToPrice();
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3_js_libs_utils__["d" /* getQueryString */])('target') === 'price') {
    scrollToPrice();
  }
}
bindEvent();
Object(__WEBPACK_IMPORTED_MODULE_1_js_libs_utils_suspension__["a" /* suspension */])();
if ($('.js-service-nav-fall').length) {
  __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_float_menu__["a" /* floatMenu */].init();
}



/***/ }),

/***/ 14:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getServiceOpenApps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getApps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getMobileappSdkList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return openService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return openOcrService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return openNewFrameService; });
/* unused harmony export webTTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return mtranslate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return lexicalAnalysist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getOtsResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getItsResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return productKesa; });
/* unused harmony export getOnlineAudioSrc */
/* unused harmony export getVoiceAudioSrc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getValidate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getIatSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getIatLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getTtsSpeakList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getTtsSign; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_cookie__ = __webpack_require__(6);
/**
 * Created by lycheng on 2017/11/23.
 * 产品服务页相关接口
 */




/**
 * 获取用户app
 * @param servicesId
 * @returns {Promise}
 */
function getServiceOpenApps(servicesId, getAppUrl) {
  return new Promise(function (resolve, reject) {
    var url = '/herapi/user/get_app_list_by_service?service_id=' + btoa(servicesId);
    jQuery.ajax({
      url: getAppUrl || url,
      type: 'get',
      dataType: 'json',
      success: function success(data) {
        resolve({
          code: 0,
          data: data
        });
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 获取用户app
 * 代替getServiceOpenApps
 */
function getApps() {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/getAppList',
      type: 'get',
      dataType: 'json',
      cache: false,
      success: function success(result) {
        resolve(result);
      },
      error: function error(s) {
        resolve({});
      }
    });
  });
}

/**
 * 开通服务的接口
 * @param servicesId
 * @param appId
 * @returns {Promise}
 */
function openService(servicesId, appId) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      type: 'get',
      url: __WEBPACK_IMPORTED_MODULE_1_config__["a" /* config */].API + 'mycloud/app/accessService',
      dataType: 'json',
      data: {
        'app_id': appId,
        'service': servicesId
      },
      success: function success(result) {
        resolve({
          code: 0,
          data: result
        });
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 开通ocr服务的接口
 * @param servicesId
 * @param appId
 * @returns {Promise}
 */
function openOcrService(servicesId, appId) {
  return new Promise(function (resolve, reject) {
    var ssoSessionId = __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_cookie__["a" /* cookie */].get('ssoSessionId');
    var accountId = __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_cookie__["a" /* cookie */].get('account_id');
    $.ajax({
      type: 'get',
      url: __WEBPACK_IMPORTED_MODULE_1_config__["a" /* config */].CONSOLE + 'dashboard/app/jsonp/service/add',
      dataType: 'jsonp',
      data: {
        appId: appId,
        services: servicesId,
        ssoSessionId: ssoSessionId,
        account_id: accountId
      },
      jsonp: 'callback',
      jsonpCallback: 'handleResponse',
      success: function success(result) {
        resolve({
          code: 0,
          data: result
        });
      },
      error: function error(result) {
        resolve(result);
      }
    });
  }).catch(function (reason) {
    console.log('catch:', reason);
  });
}

/**
 * 开通新框架服务的接口
 * @param servicesId
 * @param appId
 * @returns {Promise}
 */
function openNewFrameService(servicesId, appId) {
  return new Promise(function (resolve, reject) {
    var ssoSessionId = __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_cookie__["a" /* cookie */].get('ssoSessionId');
    var accountId = __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_cookie__["a" /* cookie */].get('account_id');
    $.ajax({
      type: 'get',
      url: __WEBPACK_IMPORTED_MODULE_1_config__["a" /* config */].CONSOLE + 'dashboard/webapi/jsonp/addService/v1',
      dataType: 'jsonp',
      data: {
        appId: appId,
        services: servicesId,
        ssoSessionId: ssoSessionId,
        account_id: accountId
      },
      jsonp: 'callback',
      jsonpCallback: 'handleResponse',
      success: function success(result) {
        resolve({
          code: 0,
          data: result
        });
      },
      error: function error(result) {
        resolve(result);
      }
    });
  }).catch(function (reason) {
    console.log('catch:', reason);
  });
}

/**
 * 语音合成的接口
 * @param params：
 * {
 *   vcn: aisxping,
 *   vol: 7,
 *   spd: medium,
 *   textPut: '', // 输入的文本
 * }
 * @returns {Promise}
 */
function webTTS(params) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      type: 'post',
      url: '/herapi/solution/synthesis',
      dataType: 'json',
      data: params,
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

function mtranslate(params) {
  // {
  //   fromLang: trans.data.source,
  //     toLang: trans.data.dist,
  //   originText: text
  // }
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/translate',
      type: 'post',
      data: params,
      success: function success(result) {
        // result.code = result.flag ? 0 : -1
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 获取开放统计的sdkList
 * @returns {Promise}
 */
function getMobileappSdkList() {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/getSdkList',
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 词法分析接口
 * @returns {Promise}
 */
function lexicalAnalysist(params) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/index/webltp',
      type: 'POST',
      dataType: 'json',
      data: params,
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 机器翻译niutrans体验接口
 * @returns {Promise}
 */
function getOtsResult(params) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/ots',
      type: 'POST',
      dataType: 'json',
      data: params,
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 机器翻译体验接口
 * @returns {Promise}
 */
function getItsResult(params) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/its',
      type: 'POST',
      dataType: 'json',
      data: params,
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 关键词提取type传：ke
 * 如果是调用情感分析type传：sa
 * 关键词 && 情感分析接口
 * @returns {Promise}
 */
function productKesa(params) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/kesa',
      type: 'POST',
      dataType: 'json',
      data: params,
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 获取在线语音合成的音频src
 * @returns {Promise}
 */
function getOnlineAudioSrc(params, challenge, validate, seccode) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/solution/synthesis/v2?challenge=' + challenge + '&validate=' + validate + '&seccode=' + seccode,
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(params),
      contentType: 'application/json; charset=utf-8',
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

function getVoiceAudioSrc(params, challenge, validate, seccode) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/solution/dictation/v2?challenge=' + challenge + '&validate=' + validate + '&seccode=' + seccode,
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(params),
      contentType: 'application/json; charset=utf-8',
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 获取极验数据进行初始化
 * @returns {Promise}
 */
function getValidate() {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/plug/validate',
      type: 'get',
      cache: false,
      dataType: 'json',
      success: function success(result) {
        resolve(result);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}
/**
 * 获取听写websocket链接
 * @returns {Promise}
 */
function getIatSign(geettestResult) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/iat_sign',
      type: 'post',
      dataType: 'json',
      cache: false,
      data: {
        challenge: geettestResult.geetest_challenge,
        validate: geettestResult.geetest_validate,
        seccode: geettestResult.geetest_seccode
      },
      success: function success(data) {
        resolve(data);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

function getIatLanguage() {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/iat_language_list',
      type: 'post',
      dataType: 'json',
      cache: false,
      success: function success(data) {
        resolve(data);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 获取合成websocket链接
 * @returns {Promise}
 */
function getTtsSign(geettestResult) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/tts_sign',
      type: 'post',
      dataType: 'json',
      cache: false,
      data: {
        challenge: geettestResult.geetest_challenge,
        validate: geettestResult.geetest_validate,
        seccode: geettestResult.geetest_seccode
      },
      success: function success(data) {
        resolve(data);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}

/**
 * 合成体验发音人参数列表获取接口
 * @param grade 发音人等级（默认是0，0特色发音人，1精品发音人）
 * @returns {Promise}
 */
function getTtsSpeakList(_ref) {
  var _ref$grade = _ref.grade,
      grade = _ref$grade === undefined ? 0 : _ref$grade;

  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/tts_language_list',
      type: 'post',
      dataType: 'json',
      data: {
        grade: grade
      },
      cache: false,
      success: function success(data) {
        resolve(data);
      },
      error: function error() {
        resolve({});
      }
    });
  });
}



/***/ }),

/***/ 16:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getApps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getPlatforms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAppServiceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getMscLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return sdkDownloadOld; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return sdkDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return openService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_config__ = __webpack_require__(0);
/**
 * Created by lycheng on 2017/12/26.
 * SDK下载相关接口
 */


/**
 * 获取用户app
 */
function getApps() {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/getAppList',
      type: 'get',
      dataType: 'json',
      cache: false,
      ifModified: true,
      success: function success(result) {
        resolve(result);
      },
      error: function error(s) {}
    });
  });
}
/**
 * 获取platform
 */
function getPlatforms() {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/platform',
      type: 'get',
      dataType: 'json',
      cache: false,
      ifModified: true,
      success: function success(result) {
        resolve(result);
      },
      error: function error(s) {}
    });
  });
}
/**
 * 获取app开通的服务
 */
function getAppServiceList(data) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/getAppServiceList?appId=' + data.appId + '&platform=' + data.platform + '&aikit=' + data.aikit,
      type: 'get',
      dataType: 'json',
      cache: false,
      ifModified: true,
      success: function success(result) {
        resolve(result);
      },
      error: function error(s) {}
    });
  });
}

/**
 * 获取MSC日志
 * @param appId
 * @returns {Promise}
 */
function getMscLog(platform) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/getMscLog?platform=' + platform,
      type: 'get',
      dataType: 'json',
      success: function success(result) {
        resolve(result);
      },
      error: function error(s) {}
    });
  });
}

/**
 * 验证服务-老的sdk下载流程
 * @param params
 */
function getChargeInfo(params) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: __WEBPACK_IMPORTED_MODULE_1_config__["a" /* config */].API + 'sdk/dispatcher/getChargeInfo',
      type: 'get',
      data: {
        app_id: params.appId,
        businessinfo: params.serviceId,
        platform: params.platform
      },
      dataType: 'json',
      success: function success(result) {
        resolve({
          code: 0,
          data: result
        });
      },
      error: function error() {}
    });
  });
}

/**
 * 老的下载流程
 * @param params
 */
function sdkDownloadOld(params) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: __WEBPACK_IMPORTED_MODULE_1_config__["a" /* config */].API + 'sdk/dispatcher/getChargeInfo',
      type: 'get',
      data: {
        app_id: params.appId,
        businessinfo: params.serviceId,
        platform: params.platform
      },
      dataType: 'json',
      success: function success(data) {
        var result = {};
        if (data.status) {
          result.code = 0;
          result.data = __WEBPACK_IMPORTED_MODULE_1_config__["a" /* config */].API + 'sdk/download?app_id=' + btoa(params.appId) + '&business=' + btoa(params.serviceId) + '&platform=' + btoa(params.platform);
        } else {
          result.flag = true;
          result.code = -1;
          result.desc = data;
        }
        resolve(result);
      },
      error: function error() {}
    });
  });
}
/**
 * 下载流程
 * @param params
 * @returns {Promise}
 */
function sdkDownload(params) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/sdkDown',
      type: 'post',
      contentType: 'application/json;charset=utf-8',
      data: JSON.stringify({
        platform: params.platform,
        appId: params.appId,
        abilities: params.abilities
      }),
      dataType: 'json',
      success: function success(result) {
        resolve(result);
      },
      error: function error() {}
    });
  });
}

/**
 * 选中服务时自动开通服务
 * @param params
 * @returns {Promise}
 */
function openService(params) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/user/service',
      type: 'get',
      data: {
        appId: params.appId,
        businessId: params.businessId
      },
      dataType: 'json',
      success: function success(result) {
        resolve(result);
      },
      error: function error() {}
    });
  });
}



/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/_babel-polyfill@6.26.0@babel-polyfill/lib/index.js
var lib = __webpack_require__(1);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/_swiper@3.2.7@swiper/dist/css/swiper.min.css
var swiper_min = __webpack_require__(21);
var swiper_min_default = /*#__PURE__*/__webpack_require__.n(swiper_min);

// EXTERNAL MODULE: ./node_modules/_swiper@3.2.7@swiper/dist/js/swiper.min.js
var js_swiper_min = __webpack_require__(22);
var js_swiper_min_default = /*#__PURE__*/__webpack_require__.n(js_swiper_min);

// EXTERNAL MODULE: ./src/js/api/services.js
var services = __webpack_require__(14);

// EXTERNAL MODULE: ./src/js/api/user.js
var user = __webpack_require__(3);

// EXTERNAL MODULE: ./src/js/api/sdk.js
var sdk = __webpack_require__(16);

// EXTERNAL MODULE: ./src/js/libs/utils.js
var utils = __webpack_require__(2);

// EXTERNAL MODULE: ./src/js/libs/utils-layer.js
var utils_layer = __webpack_require__(19);

// EXTERNAL MODULE: ./src/js/libs/utils-login.js + 5 modules
var utils_login = __webpack_require__(7);

// EXTERNAL MODULE: ./src/js/config/prod.js
var prod = __webpack_require__(0);

// CONCATENATED MODULE: ./src/js/libs/utils-services-open-html.js
/**
 * Created by lycheng on 2017/11/29.
 * 开通服务弹出层获取数据后的html拼接
 */

function getHtml(data, serviceConfig) {
  var html;
  if (data) {
    data = data || [];
    serviceConfig = serviceConfig || {};
    if (!data.length) {
      // 没有应用
      html = '<div class="service-open-item service-open-tip service-open-no-app">\n      ' + (serviceConfig.noAppTip || '您还未创建应用，请先创建应用。') + '\n    </div>';
    } else {
      var unOpenAppsHtml = '';
      var unOpenHtml = '';
      var openedAppsHtml = '';
      var openedHtml = '';
      var allOpenedHtml = '';
      var defaultTipHtml = '';
      if (serviceConfig.defaultTip) {
        defaultTipHtml = '<div class="service-open-item service-open-tip service-open-default-tip">\n      ' + serviceConfig.defaultTip + '\n    </div>';
      }
      //  开通服务的apps
      if (data.length) {
        for (var i = 0; i < data.length; i++) {
          openedAppsHtml += '<li class="swiper-slide " \ndata-app-id="' + data[i].appId + '"\ndata-app-name="' + data[i].appName + '"\ntitle="' + data[i].appName + '">\n              <i class="icons icons-app-default"></i>\n              <span>' + data[i].appName + '</span>\n            </li>';
        }
        openedHtml = '<div class="service-open-item service-open-opened">\n        ' + (serviceConfig.openedTitle || serviceConfig.unOpenTitle ? '<div class="service-open-title">' + (serviceConfig.unOpenTitle || serviceConfig.openedTitle) + '</div>' : '') + '\n        <div class="service-open-apps service-opened-apps">\n          <div class="swiper-container">\n            <ul class="swiper-wrapper">\n              ' + openedAppsHtml + '\n            </ul>\n            <div class="swiper-button-prev swiper-button"></div>\n            <div class="swiper-button-next swiper-button"></div>\n          </div>\n        </div>\n      </div>';
      }
      html = defaultTipHtml + allOpenedHtml + unOpenHtml + openedHtml + ('<div class="modal-buttons">\n      <a class="modal-button modal-button-ok">' + (serviceConfig.okButton || '确定') + '</a>\n      <a class="modal-button modal-button-cancle">\u53D6\u6D88</a>\n    </div>\n    ');
    }
  } else {
    if (serviceConfig === 'loading') {
      html = '<div class="loader-wrap loader-ball-spin-fade">\n  <div class="loader-inner">\n    <i class="icons icons-loader"></i>\n    <i class="icons icons-loader"></i>\n    <i class="icons icons-loader"></i>\n    <i class="icons icons-loader"></i>\n    <i class="icons icons-loader"></i>\n    <i class="icons icons-loader"></i>\n    <i class="icons icons-loader"></i>\n    <i class="icons icons-loader"></i>\n  </div>\n</div>';
    } else {
      html = '<div class="service-open-item service-open-tip">\n        \u6570\u636E\u83B7\u53D6\u5931\u8D25\n      </div>';
    }
  }
  return html;
}

// CONCATENATED MODULE: ./src/js/libs/utils-services-open.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return showserviceOpenModal; });
/* unused harmony export closeserviceOpenModal */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return init; });
/**
 * Created by lycheng on 2017/11/29.
 * 如果需要特殊的定制显示，请在调用init时传递数据，
 * 如果一个页面中有多个开通服务，请在调用showserviceOpenModal时传递数据，
 * 如果已有的不能满足你的需求，请在调用是通过传递参数的方式进行配置
 * 杜绝／鄙视使用像 if(serviceId === 'xxx')的行为
 * 杜绝／鄙视使用像 if(serviceId === 'xxx')的行为
 * 杜绝／鄙视使用像 if(serviceId === 'xxx')的行为
 */











var ocrList = ['bankcard', 'general', 'hw', 'idcard', 'business_card', 'business_license', 'wfv', 'wwv', 'wsf', 'wcf', 'wtf', 'waf', 'dp', 'srl', 'sdp', 'cws-pos-ner', 'its', 'qbh', 'wsd', 'invoice', 'scene', 'currency', 'sex-age-expression-face_score', 'sa', 'ke', 'sdgp', 'recognize_document', 'rta', 'esriat', 'znyj'];
var newFrameList = ['igr_gray', 'itr'];
var serviceOpen = {
  config: {
    modalTitle: '选择应用',
    // 弹出框
    modalContainer: '.modal-wrapper-service-open',
    // 默认提示文字：如麦克风阵列的
    defaultTip: '',
    allOpenedTip: '',
    noAppTip: '',
    unOpenTitle: '',
    openedTitle: '',
    // 没有选择应用直接点击开通按钮的提示
    alertTip: '请选择应用',
    // 通过数据拼接的html追加的位置
    $container: $('.modal-wrapper-service-open .service-open-content'),
    // 是否允许被开通
    enableOpen: true,
    // 跳转链接中需要额外的参数
    urlParams: {}
  },
  data: {
    appId: '',
    appName: '',
    serviceId: '',
    serviceTitle: '',
    // 是否已经开通
    opened: '',
    // 详情页链接
    detailUrl: '',
    // 去开通详情页链接
    toOpenUrl: '',
    // 详情页是否新打开一个窗口
    detailTarget: '_self',
    getAppUrl: '',
    // app_id在url中的key
    appIdKey: 'app_id',
    // 是否需要base64 appid
    needBase64: true,
    // 是否需要appOs
    needAppOs: false,
    // 是否需要businessId
    needBusinessId: false
  }
  /**
   * 打开弹出层
   * @param modalConfig 会覆盖serviceOpen.config中的数据
   * @param serviceData 会覆盖serviceOpen.data中的数据
   * @param modalContainer
   */
};function showserviceOpenModal(modalConfig, serviceData, modalContainer) {
  modalConfig && (serviceOpen.config = $.extend(serviceOpen.config, modalConfig));
  serviceData && (serviceOpen.data = $.extend(serviceOpen.data, serviceData));
  serviceOpen.config.modalTitle && $(serviceOpen.config.modalContainer + ' .modal-title').text(serviceOpen.config.modalTitle);
  serviceOpen.config.modalContainer = modalContainer || serviceOpen.config.modalContainer;
  rendModal();
}
function closeserviceOpenModal(modalContainer) {
  utils_layer["a" /* layer */].close(modalContainer || serviceOpen.config.modalContainer);
  resetModal();
}
// 重置modal
function resetModal() {
  serviceOpen.data.appId = '';
  var $modal = $(serviceOpen.config.modalContainer);
  var $serviceAgreement = $modal.find('#service_agreement').get(0);
  $modal.find('.modal-button-ok').removeClass('disabled');
  $serviceAgreement && ($serviceAgreement.checked = true);
}
// 渲染弹出层
function rendModal(serviceId, serviceConfig) {
  serviceId = serviceId || serviceOpen.data.serviceId;
  serviceConfig = serviceConfig || {
    defaultTip: serviceOpen.config.defaultTip,
    noAppTip: serviceOpen.config.noAppTip,
    allOpenedTip: serviceOpen.config.allOpenedTip,
    unOpenTitle: serviceOpen.config.unOpenTitle,
    openedTitle: serviceOpen.config.openedTitle,
    agreementTitle: serviceOpen.data.agreementTitle,
    agreementUrl: serviceOpen.data.agreementUrl,
    serviceTitle: serviceOpen.data.serviceTitle,
    okButton: serviceOpen.config.okButton,
    enableOpen: serviceOpen.config.enableOpen
  };
  user["b" /* checkLogin */]().then(function (loginResult) {
    var html;
    if (loginResult.data) {
      utils_layer["a" /* layer */].open(serviceOpen.config.modalContainer);
      html = getHtml('', 'loading');
      serviceOpen.config.$container.html(html);
      services["a" /* getApps */]().then(function (result) {
        if (result.code === 0 || result.code === '0') {
          html = getHtml(result.data, serviceConfig);
          serviceOpen.config.$container.html(html);
          if (result.data.length) {
            var container = '.service-opened-apps .swiper-container';
            var $swiperButton = $(container + ' .swiper-button');
            new Swiper('.service-opened-apps .swiper-container', { // eslint-disable-line
              slidesPerView: 6,
              slidesPerGroup: 6,
              spaceBetween: 10,
              prevButton: '.service-opened-apps .swiper-button-prev',
              nextButton: '.service-opened-apps .swiper-button-next'
            });
            if (result.data.length <= 6) {
              $swiperButton.hide();
            } else {
              $swiperButton.show();
            }
          }
        } else {
          html = getHtml();
          serviceOpen.config.$container.html(html);
        }
      });
    } else {
      Object(utils_login["b" /* showLoginModal */])();
    }
  });
}
/**
 * 开通服务
 * @param serviceId
 * @param appId
 * @param detailUrl
 */
function openService(serviceId, appId, detailUrl) {
  var newWindow;
  serviceId = serviceId || serviceOpen.data.serviceId;
  appId = appId || serviceOpen.data.appId;
  detailUrl = detailUrl || serviceOpen.data.detailUrl;
  if (serviceOpen.data.opened) {
    // 进入详情页
    toDetail(serviceId, appId, detailUrl);
  } else if (!appId) {
    toDetail(serviceId, appId);
  } else {
    // 去开通
    // 解决ajax请求无法window.open窗口的问题
    if (serviceOpen.data.detailTarget === '_blank') {
      newWindow = window.open('/default/loading', '_blank');
    }
    // 判断是否是ocr
    if (ocrList.includes(serviceId)) {
      services["m" /* openOcrService */](serviceId, appId).then(function (result) {
        if (result.code === 0 || result.code === '0') {
          // 进入详情页
          toDetail(serviceId, appId, detailUrl, newWindow);
        } else {
          // 开通失败
          jAlert(result.desc);
        }
      });
    } else if (newFrameList.includes(serviceId)) {
      services["l" /* openNewFrameService */](serviceId, appId).then(function (result) {
        if (result.code === 0 || result.code === '0') {
          // 进入详情页
          toDetail(serviceId, appId, detailUrl, newWindow);
        } else {
          // 开通失败
          jAlert(result.desc);
        }
      });
    } else {
      services["n" /* openService */](serviceId, appId).then(function (result) {
        if (result.code === 0 || result.code === '0') {
          // 进入详情页
          toDetail(serviceId, appId, detailUrl, newWindow);
        } else {
          // 开通失败
          jAlert(result.desc);
        }
      });
    }
  }
}
/**
 * 进入服务详情页
 * @param serviceId
 * @param appId
 * @param detailUrl
 */
function toDetail(serviceId, appId, detailUrl, newWindow) {
  serviceId = serviceId || serviceOpen.data.serviceId;
  appId = appId || serviceOpen.data.appId;
  if (!serviceOpen.data.opened && serviceOpen.data.toOpenUrl) {
    // toOpenUrl
    detailUrl = detailUrl || serviceOpen.data.toOpenUrl;
  } else {
    detailUrl = detailUrl || serviceOpen.data.detailUrl;
  }
  // 拼接跳转的链接
  detailUrl = Object(utils["e" /* setQueryString */])(serviceOpen.data.appIdKey, serviceOpen.data.needBase64 ? btoa(serviceOpen.data.appId) : serviceOpen.data.appId, detailUrl);
  // 链接添加appOs,businessId参数
  if (serviceOpen.data.needBusinessId) detailUrl = Object(utils["e" /* setQueryString */])('businessId', btoa(serviceId), detailUrl);
  if (serviceOpen.data.needAppOs && serviceOpen.data.appOs) detailUrl = Object(utils["e" /* setQueryString */])('appOs', serviceOpen.data.appOs, detailUrl);
  // 链接中的其他参数
  for (var p in serviceOpen.config.urlParams) {
    detailUrl = Object(utils["e" /* setQueryString */])(p, serviceOpen.config.urlParams[p] || serviceOpen.data[p], detailUrl);
  }
  if (!appId) {
    // 没有选择appId
    jAlert(serviceOpen.config.alertTip);
  } else {
    closeserviceOpenModal();
    if (newWindow) {
      // ajax请求后在新的窗口中打开
      newWindow.location.href = detailUrl;
    } else {
      window.open(detailUrl, serviceOpen.data.detailTarget);
    }
  }
}
function bindEvent() {
  var $modal = $(serviceOpen.config.modalContainer);
  // modal中的按钮
  $modal.on('click', '.modal-button-ok', function () {
    // 确定开通
    var $this = $(this);
    if ($this.hasClass('disabled')) {
      return;
    }
    if (serviceOpen.config.enableOpen) {
      openService();
    } else {
      toDetail();
    }
  }).on('click', '.modal-button-cancle, .modal-close', function () {
    closeserviceOpenModal();
  }).on('click', '.service-opened-apps li', function () {
    // 已经开通过的app
    var $appsBox = $('.service-open-apps');
    $appsBox.find('li.active').removeClass('active');
    $(this).addClass('active');
    serviceOpen.data.appId = $(this).data('appId');
    serviceOpen.data.appOs = $(this).data('appOs');
    serviceOpen.data.appName = $(this).data('appName');
    serviceOpen.data.opened = true;
  }).on('click', '.service-unopen-apps li', function () {
    // 没有开通过的app
    var $appsBox = $('.service-open-apps');
    $appsBox.find('li.active').removeClass('active');
    $(this).addClass('active');
    serviceOpen.data.appId = $(this).data('appId');
    serviceOpen.data.appOs = $(this).data('appOs');
    serviceOpen.data.appName = $(this).data('appName');
    serviceOpen.data.opened = false;
  }).on('change', '#service_agreement', function () {
    // 协议
    var $okButton = $modal.find('.modal-button-ok');
    if (this.checked) {
      $okButton.removeClass('disabled');
    } else {
      $okButton.addClass('disabled');
    }
  });
}
/**
 * 初始化
 * @param modalConfig 会覆盖serviceOpen.config中的数据
 * @param serviceData 会覆盖serviceOpen.data中的数据
 */
function init(modalConfig, serviceData) {
  serviceOpen.data.$modal = $(serviceOpen.config.modalContainer);
  serviceOpen.data.serviceId = serviceOpen.data.$modal.data('serviceId');
  serviceOpen.data.serviceTitle = serviceOpen.data.$modal.data('serviceTitle');
  serviceOpen.data.detailUrl = serviceOpen.data.$modal.data('detailUrl');
  var detailOrigin = serviceOpen.data.detailUrl && serviceOpen.data.detailUrl.substr(0, serviceOpen.data.detailUrl.indexOf('/'));
  if (detailOrigin && detailOrigin !== location.origin) {
    serviceOpen.data.detailTarget = '_blank';
  }
  serviceOpen.data.agreementTitle = serviceOpen.data.$modal.data('agreementTitle');
  serviceOpen.data.agreementUrl = serviceOpen.data.$modal.data('agreementUrl');
  modalConfig && (serviceOpen.config = $.extend(serviceOpen.config, modalConfig));
  serviceData && (serviceOpen.data = $.extend(serviceOpen.data, serviceData));
  bindEvent();
}


/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/js/api/user.js
var user = __webpack_require__(3);

// EXTERNAL MODULE: ./src/js/libs/utils.js
var utils = __webpack_require__(2);

// EXTERNAL MODULE: ./src/js/config/prod.js
var prod = __webpack_require__(0);

// EXTERNAL MODULE: ./src/scss/component/announcement.scss
var announcement = __webpack_require__(5);
var announcement_default = /*#__PURE__*/__webpack_require__.n(announcement);

// EXTERNAL MODULE: ./src/js/libs/utils-cookie.js
var utils_cookie = __webpack_require__(6);

// CONCATENATED MODULE: ./src/js/libs/utils-announcement.js
/**
 * 公告
 */


var _countDown = null;
var ancmtModel = {
  addEvent: function addEvent() {
    $('.ancmt-detail').on('click', '.ancmt-bullet-box-close-btn', function () {
      $('.ancmt-wrap').hide();
    });
    $('body').not('.ancmt-wrap').bind('click', function () {
      $('.ancmt-wrap').hide();
    });
  },
  countDown: function countDown() {
    var allTime = 15;
    _countDown = setInterval(function () {
      $('#abb_num').text(--allTime);
      if (allTime < 0) {
        $('.ancmt-wrap').hide();
        clearInterval(_countDown);
      }
    }, 1000);
  },
  fireAction: function fireAction() {
    $('#open_announcement').bind('click', function (e) {
      e.stopPropagation();
      $('.ancmt-wrap').show();
    });
  },
  showTop: function showTop() {
    if (!utils_cookie["a" /* cookie */].get('top_banner_closed')) {
      $('#top_banner_wrap').show();
    }
  },
  bindTopAction: function bindTopAction() {
    $('#close_banner_top').bind('click', function () {
      $('#top_banner_wrap').hide();
      var curDate = new Date();
      var curTamp = curDate.getTime();
      var curWeeHours = new Date(curDate.toLocaleDateString()).getTime() - 1;
      var passedTamp = curTamp - curWeeHours;
      var leftTamp = 24 * 60 * 60 * 1000 - passedTamp;
      var leftTime = new Date();
      leftTime.setTime(leftTamp + curTamp);
      utils_cookie["a" /* cookie */].pureSet('top_banner_closed', true, leftTime.toGMTString() + ';path=/');
    });
  },
  init: function init() {
    var that = this;
    that.addEvent();
    that.fireAction();
    that.showTop();
    that.bindTopAction();
    // that.countDown()
  }
};
ancmtModel.init();
// CONCATENATED MODULE: ./src/js/libs/utils-suspension.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return suspension; });
/**
 * Created by lycheng on 2017/11/29.
 * 悬浮的狗，返回顶部
 */





function initZcScript(w, d, e, x) {
  w[e] = function () {
    w.cbk = w.cbk || [];
    w.cbk.push(arguments);
  };
  x = d.createElement("script");
  x.async = true;
  x.id = "zhichiScript";
  x.className = "im-btn";
  x.src = "https://chat.sobot.com/chat/frame/v2/entrance.js?sysnum=1f851a5acb6e4f408a3e3e5487750951";
  d.body.appendChild(x);
}

function initZc(userInfo) {
  var nick = userInfo.nickname;
  var nickLogin = userInfo.login;
  var nickMiddle = nickLogin.length / 2;
  var isEven = nickLogin.length % 2 === 0;
  var nickEncry = isEven ? nickMiddle : Math.ceil(nickMiddle) - 2;
  nickLogin = nickLogin.length > 5 ? nickLogin.replace(nickLogin.substring(nickEncry, nickEncry + 2), "***") : nickLogin;
  user["a" /* aesEncry */](userInfo.uid).then(function (r) {
    var uid = r.data;
    var isZcBack = window.location.search.includes("isZc=1");
    initZcScript(window, document, "zc");
    var args = {
      customField7: uid
    };
    var prms = {
      uid: uid
    };
    zc("config", {
      uname: nick || nickLogin,
      custom: true, // 设置自定义
      color: "2277e6",
      customer_fields: JSON.stringify(args),
      params: JSON.stringify(prms),
      partnerid: uid,
      auto_expand: isZcBack
    });
    zc("dynamic_ready");
  });
}
/**
 * 右侧悬浮
 * @param s:距离顶部的高度
 */
function suspension() {
  var $suspension = $(".affix");
  var $backTop = $(".affix-bottom");
  var $panelSuggest = $(".affix-panel-content__suggest");
  var $panelApplet = $(".affix-panel-content__applet");
  var $panelAdvice = $(".affix-panel-content__advice");
  var $iframe = $(".affix-panel-content__iframe");
  var timer = null;
  $(window).scroll(function () {
    var scrollTop = $(window).scrollTop();
    if (scrollTop < 204) {
      $suspension.removeClass("affix_fixed");
    } else {
      $suspension.addClass("affix_fixed");
    }
    if (scrollTop > 204) {
      $backTop.show();
    } else {
      $backTop.hide();
    }
  });
  $backTop.click(function () {
    $("body, html").animate({ scrollTop: 0 }, 500);
    return false;
  });

  $(".affix-advice").click(function () {
    clearTimeout(timer);
    user["e" /* getUserinfo */]().then(function (res) {
      if (res.code === 80000) {
        var jumpBack = typeof window !== "undefined" ? Base64.encode(window.location.href) : "";
        window.location.href = prod["a" /* config */].PASSPORT_NEW + "/login?jump=" + jumpBack;
      } else {
        $panelAdvice.removeClass("show");
        $panelAdvice.addClass("show");
        $iframe[0].contentWindow.postMessage({ type: 'showBotChat' }, '*');
      }
    });
  });
  $(".affix-suggest").mouseenter(function () {
    clearTimeout(timer);
    $panelApplet.removeClass("show");
    $panelSuggest.addClass("show");
  });
  $(".affix-suggest").mouseleave(function () {
    timer = setTimeout(function () {
      $panelSuggest.removeClass("show");
      clearTimeout(timer);
    }, 500);
  });
  $panelSuggest.mouseenter(function () {
    clearTimeout(timer);
    $panelSuggest.addClass("show");
  });
  $panelSuggest.mouseleave(function () {
    timer = setTimeout(function () {
      $panelSuggest.removeClass("show");
      clearTimeout(timer);
    }, 500);
  });
  $(".affix-applet").mouseenter(function () {
    $panelSuggest.removeClass("show");
    $panelApplet.addClass("show");
  });
  $(".affix-applet").mouseleave(function () {
    $panelApplet.removeClass("show");
  });

  function checkImLog() {
    user["e" /* getUserinfo */]().then(function (result) {
      if (result.code === 80000) {
        $(".im-icon").removeClass("im-btn");
        $(".im-icon").click(function () {
          var jumpBack = typeof window !== "undefined" ? Base64.encode(Object(utils["e" /* setQueryString */])("isZc", 1)) : "";
          window.location.href = prod["a" /* config */].PASSPORT + "/login?jump=" + jumpBack;
        });
      } else {
        initZc(result.data);
      }
    });
  }

  // checkImLog();
}

var methods = {
  setIframe: function setIframe(w, h) {
    $(".affix-panel-content__iframe").width(w).height(h);
  }
};
$(function () {
  window.addEventListener("message", function (e) {
    if (e.data.type === 'dom') {
      var data = e.data.data;

      var width = data.width;
      var height = data.height + 12;
      methods.setIframe(width, height);
    }
    if (e.data.type === 'close') {
      $(".affix-panel-content__advice").removeClass('show');
    }
  });
});


/***/ }),

/***/ 5:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 734:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scss_services_pornContentFilterRecg_scss__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scss_services_pornContentFilterRecg_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_scss_services_pornContentFilterRecg_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_libs_utils_services__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_libs_utils_services_open__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_config__ = __webpack_require__(0);





Object(__WEBPACK_IMPORTED_MODULE_3_js_libs_utils_services_open__["a" /* init */])();
$(function () {
  $('.to-service-open').click(function () {
    Object(__WEBPACK_IMPORTED_MODULE_3_js_libs_utils_services_open__["b" /* showserviceOpenModal */])({
      urlParams: { 'currPage': '1' }
    }, {
      detailUrl: __WEBPACK_IMPORTED_MODULE_4_config__["a" /* config */].CONSOLE + 'app/myapp',
      appIdKey: 'keyword',
      needBase64: false
    });
  });
  Object(__WEBPACK_IMPORTED_MODULE_2_js_libs_utils_services__["b" /* serviceTopbar */])();
});

/***/ }),

/***/ 735:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[734]);


// WEBPACK FOOTER //
// js/services/pornContentFilterRecg.3152392d3367b88a9dbf.bundle.js